import i18n from '@/i18n'
// 获取菜单
export const getMenus = function(item) {
  let data1 = {
    // 管理员菜单
    menus: [
      {
        children: [],
        icon: 'index',
        id: '18',
        name: i18n.t('utils.menu.2595925-0'),
        url: '/index'
      },
      {
        children: [
          {
            id: '2201',
            name: i18n.t('utils.menu.2595925-1'),
            url: '/system-settings/role-management',
            children: []
          },
          {
            id: '2202',
            name: i18n.t('utils.menu.2595925-2'),
            url: '/system-settings/user-management',
            children: []
          },
          {
            id: '2203',
            name: i18n.t('utils.menu.2595925-3'),
            url: '/system-settings/audit-management',
            children: []
          },
          {
            id: '2204',
            name: i18n.t('utils.menu.2595925-4'),
            url: '/system-settings/category-management',
            children: []
          }
        ],
        icon: 'system',
        id: '23',
        name: i18n.t('utils.menu.2595925-5'),
        url: '/system-settings'
      },
      {
        children: [],
        icon: 'guide',
        id: '24',
        name: i18n.t('utils.menu.2595925-6'),
        url: '/guide-to-use'
      }
    ]
  }
  let data2 = {
    // 发布者菜单
    menus: [
      {
        children: [],
        icon: 'index',
        id: '18',
        name: i18n.t('utils.menu.2595925-0'),
        url: '/index'
      },
      {
        children: [],
        icon: 'guide',
        id: '23',
        name: i18n.t('utils.menu.2595925-6'),
        url: '/guide-to-use'
      }
    ]
  }
  return item ? data1 : data2
}
